import { Entity, FieldType, PersistenceType } from 'gossamer-unified';

export interface PushNotificationDeliveryStatsRow {
  hour: string;
  notification_type: string;
  total_sent: number;
  displayed: number;
  clicked: number;
  dismissed: number;
  likely_failed: number;
  display_rate_pct: number | null;
  click_through_rate_pct: number | null;
}

export const PushNotificationDeliveryStats: Entity<PushNotificationDeliveryStatsRow> = {
  id: 'PushNotificationDeliveryStats',
  title: 'Push Notification Delivery Stats',
  service: 'main',
  rowLabel: (row: PushNotificationDeliveryStatsRow) =>
    `${new Date(row.hour).toLocaleString()} - ${row.notification_type}`,
  primaryKeyFields: ['hour', 'notification_type'],
  source: {
    tableName: 'public.push_notification_delivery_stats',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [['hour', 'DESC']],
  defaultFilters: [],
  fields: {
    hour: {
      seq: 5,
      type: FieldType.Datetime,
      label: 'Hour',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    notification_type: {
      seq: 10,
      type: FieldType.Options,
      label: 'Type',
      listColumn: true,
      options: [
        { id: 'message', label: 'Message' },
        { id: 'test', label: 'Test' },
        { id: 'system', label: 'System' },
        { id: 'reminder', label: 'Reminder' },
        { id: 'alert', label: 'Alert' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    total_sent: {
      seq: 15,
      type: FieldType.Integer,
      label: 'Total Sent',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    displayed: {
      seq: 20,
      type: FieldType.Integer,
      label: 'Displayed',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    clicked: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Clicked',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    dismissed: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Dismissed',
      persistence: PersistenceType.BackEndManaged,
    },
    likely_failed: {
      seq: 35,
      type: FieldType.Integer,
      label: 'Likely Failed',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    display_rate_pct: {
      seq: 40,
      type: FieldType.Decimal,
      label: 'Display Rate %',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    click_through_rate_pct: {
      seq: 45,
      type: FieldType.Decimal,
      label: 'Click-Through Rate %',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
